import { render, staticRenderFns } from "./Wp_jd_share_with_link_model.vue?vue&type=template&id=208142bc&scoped=true&"
import script from "./Wp_jd_share_with_link_model.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_share_with_link_model.vue?vue&type=script&lang=js&"
import style0 from "./Wp_jd_share_with_link_model.vue?vue&type=style&index=0&id=208142bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208142bc",
  null
  
)

export default component.exports